import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0 font-heading">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-50">
          <i className="ri-error-warning-line text-3xl text-primary-500" />
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-800 font-heading">
          {t('notFound.title')}
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-md">
          {t('notFound.desc')}
        </p>
        <Link
          to="/"
          className="btn-primary mt-8 inline-flex"
        >
          <div className="w-4 h-4 flex items-center justify-center mr-2">
            <i className="ri-arrow-left-line text-sm" />
          </div>
          {t('notFound.back')}
        </Link>
      </div>
    </div>
  );
}